import { createBlog } from "../../../redux/specialist-slices/blog.slice";
import { ckEditorConfig } from "../../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useEffect, useRef, useState } from "react";
import SkeletonImage from "../../ui/SkeletonImage";
import { useToast } from "../../../hooks/useToast";
import InputFieldB from "../../ui/InputFieldB";
import SelectInput from "../../ui/SelectInput";
import { useNavigate } from "react-router-dom";
import Icons from "../../../assets/js/Icons";
import { ClassicEditor } from "ckeditor5";
import "ckeditor5/ckeditor5.css";

import {
  Box,
  Button,
  CircularProgress,
  Grid2 as Grid,
  Icon,
  InputLabel,
  Typography,
} from "@mui/material";
import { handleRetrieveBlogCategories } from "../../../redux/public-slices/blog.slice";

function AddBlog() {
  const toast = useToast();
  const files = useRef("");
  const editorRef = useRef("");
  const navigate = useNavigate();
  const categoryRef = useRef("");
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const { loadings } = useSelector((state) => state.otherSlice);

  const handleretrieveAll = async () => {
    dispatch(handleRetrieveBlogCategories({ limit: 100 }))
      .unwrap()
      .then((data) => {
        setCategories(data.records || []);
      })
      .catch(() => { });

  };

  const handleImagePreview = (e) => {
    files.current = Array.from(e.target.files);
    const views = files.current?.map((img) => URL.createObjectURL(img));
    setImage(views);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = Object.fromEntries(new FormData(form));
    formData.banner = files?.current || null;
    formData.description = editorRef?.current?.data || null;
    formData.categoryId = categoryRef?.current?.value?._id || null;

    if (
      Object.values(formData)?.some((value) =>
        typeof value === "string"
          ? value?.trim() === "" || !value
          : Array.isArray(value) && !value?.length
            ? true
            : !value
      )
    ) {
      return toast.error("Please fill all required field!");
    }

    dispatch(createBlog(formData))
      .unwrap()
      .then(() => {
        form.reset();
        setTimeout(() => {
          navigate("/specialist/profile/all-blog");
        }, 500);
      })
      .catch(() => { });
  };

  useEffect(() => {
    handleretrieveAll();

    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        p: 3,
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Typography variant="dashboardSectionTitle">Add new blog post</Typography>

      <Box className="page-content">
        <Grid container spacing={3} component="form" onSubmit={handleSubmit}>
          <Grid size={{ xs: 12, xl: 12 }}>
            <InputFieldB
              name="title"
              label="Title *"
              variant="outlined"
              placeholder="Enter Title"
              labelvariant="InputLabelA"
            // helperText={helperText}
            />
          </Grid>
          <Grid size={{ xs: 12, xl: 6 }}>
            <SelectInput
              label="Category *"
              renderValueKey="name"
              inputRef={categoryRef}
              placeholder="Enter Question"
              selectLabel="Select Category"
              // loading={loadings?.retrieveAll}
              options={categories || []}
            />
          </Grid>

          <Grid size={12} sx={{ ".ck-content": { minHeight: "200px" } }}>
            <CKEditor
              ref={editorRef}
              onChange={(_, editor) => {
                editorRef.current.data = editor.getData();
              }}
              editor={ClassicEditor}
              config={ckEditorConfig}
            />
          </Grid>
          <Grid size={12}>
            <Grid container spacing={2}>
              <Grid>
                <InputLabel
                  sx={{
                    mb: 0,
                    height: 200,
                    borderRadius: "8px",
                    border: "1px dashed",
                    placeContent: "center",
                    borderColor: "primary.main",
                    display: image ? "block" : "grid",
                    width: "200px",
                  }}
                >
                  {image ? (
                    <SkeletonImage
                      sx={{
                        objectFit: "contain",
                        width: {
                          xs: "100%",
                        },
                      }}
                      src={image || null}
                    />
                  ) : (
                    <>
                      <Icon
                        sx={{
                          fontSize: "100px",
                          color: "other.color2",
                          m: "auto",
                          svg: { display: "block" },
                        }}
                      >
                        <Icons.ImageSolid />
                      </Icon>
                      <Typography mb={1.5} color="other.color2">
                        Upload image
                      </Typography>
                    </>
                  )}
                  <input
                    style={{ display: "none" }}
                    onChange={handleImagePreview}
                    accept="image/*"
                    type="file"
                  />
                  {/*  */}
                </InputLabel>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Button
              type="submit"
              variant="contained"
              sx={{
                minWidth: "150px",
                justifyContent: "center",
              }}
              endIcon={
                loadings?.create && (
                  <CircularProgress size={22} color="text" thickness={6} />
                )
              }
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default AddBlog;
